import React from 'react';
import connect from "../../assets/apiconnect.png";
import { useNavigate } from 'react-router-dom';

const APIExchange = () => {
  const navigate = useNavigate();

  const handleConnectClick = () => {
    navigate('/dashboard/connect-exchange');
  };

  const handlePaperTradingClick = () => {
    navigate('/dashboard/connect-exchange?mode=Paper');
  };

  return (
    <div className="grid grid-cols-1 md:grid-cols-3 gap-6 p-6 text-white  mx-auto">
      <div className="col-span-1 md:col-span-2  backdrop-blur-md rounded-xl shadow-2xl p-6 md:p-8 transition-all duration-300 border border-primary">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 items-center">
          <div className="col-span-1 order-1 md:order-2">
            <img
              src={connect}
              alt="connect"
              className="w-full h-auto rounded-lg transform hover:scale-105 transition-transform duration-300"
            />
          </div>
          <div className="col-span-2 order-2 md:order-1">
            <h2 className="text-2xl font-bold mb-4 text-Profitslatheme-neonMed tracking-tight">
              Connect Your Trading Account
            </h2>
            <p className="mb-4 text-Profitslatheme-colorDark text-lg leading-relaxed">
              Seamlessly link your trading account to unlock real-time insights, leverage {import.meta.env.VITE_PROJECT}'s smart tools, and watch your portfolio thrive.
            </p>
            <p className="mb-4 text-Profitslatheme-colorDark text-lg leading-relaxed">
              Not ready to dive in? Try our risk-free demo account and trade with confidence.
            </p>
          </div>
        </div>
        <p className="mt-6 mb-8 text-Profitslatheme-colorDark text-md">
          Compatible with Binance, KuCoin, OKX, Coinbase, Kraken & many more exchanges.
        </p>
        <div className="flex flex-col sm:flex-row gap-4 justify-center md:justify-start">
          <button
            onClick={handleConnectClick}
            className="group flex items-center px-4 md:px-6 py-3 bg-primary text-secondary font-semibold rounded-lg hover:bg-primary transition-all duration-300 transform hover:-translate-y-1 hover:shadow-lg"
          >
            <i className="fas fa-link mr-2 group-hover:animate-pulse"></i>
            Connect Exchange
          </button>
          <button
            onClick={handlePaperTradingClick}
            className="group flex items-center px-6 py-3 bg-gray-700 text-white font-semibold rounded-lg hover:bg-gray-600 transition-all duration-300 transform hover:-translate-y-1 hover:shadow-lg"
          >
            <i className="fas fa-plus mr-2 group-hover:animate-pulse"></i>
            Add Paper Trading
          </button>
        </div>
      </div>
      <div className="col-span-1  backdrop-blur-md rounded-xl shadow-2xl p-8 transition-all duration-300 hover:shadow-primary/50 border border-primary">
        <h3 className="text-xl font-bold mb-6 text-primary tracking-tight">
          How to Connect Your Exchange
        </h3>
        <ol className="list-decimal list-inside space-y-4 text-Profitslatheme-colorDark text-lg leading-relaxed">
          <li className="hover:text-primary transition-colors duration-200">
            Click "Connect Exchange" to begin.
          </li>
          <li className="hover:text-primary transition-colors duration-200">
            Choose your preferred exchange.
          </li>
          <li className="hover:text-primary transition-colors duration-200">
            Enter your API key and secret key securely.
          </li>
          <li className="hover:text-primary transition-colors duration-200">
            Hit "Connect" to link your account.
          </li>
        </ol>
      </div>
    </div>
  );
};

export default APIExchange;